export type Addressable = {
  addressStreet: string | null,
  addressLineTwo?: string | null,
  addressCity: string | null,
  addressState: string | null,
  addressZip: string | null,
  addressPlaceId?: string | null,
}

export const stateCodes = [
  "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA",
  "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD",
  "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ",
  "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC",
  "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY",
  "DC" // Include District of Columbia
];

let stateCodeSet: Set<string>;

export const isAddressable = (object: Partial<Addressable>): object is Addressable => {
  const fields = new Set(Object.keys(object));
  return (['addressStreet', 'addressCity', 'addressState', 'addressZip'].every(s => fields.has(s)))
}

export const validateStateCode = (stateCode: string): boolean => {
  if (!stateCodeSet) {
    stateCodeSet = new Set(stateCodes);
  }
  return stateCodeSet.has(stateCode);
}

export const PhoneRegex = /^(?:\+1\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
